if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTextTutorialNav)
} else {
    initTextTutorialNav()
}

async function initTextTutorialNav() {
    setTimeout(async () => {
        const [{createApp}, {
            buttonFavIconPackage,
            buttonFavIconPackageNotLogin
        }, DownloadInfo, CreditsPopup] = await Promise.all([
            import("vue"),
            import("@/libs/buttonEvents.ts"),
            import("@/components/Frontend/DownloadInfo.vue"),
            import("@/components/Frontend/CreditsPopup.vue")
        ])

        buttonFavIconPackage()
        buttonFavIconPackageNotLogin()

        const app = createApp({})
        const components = {
            "credits-popup": CreditsPopup.default,
            "download-info": DownloadInfo.default
        }
        Object.entries(components).forEach(([name, component]) => {
            app.component(name, component)
        })
        app.mount("#app")

        initializeAccordion()
    }, 600)
}

function initializeAccordion() {
    window.addEventListener(
        "load",
        () => {
            const navigationCatalog = document.getElementById("navigationCatalogTutorial")
            const accordion = document.querySelector(".accordion")
            if (navigationCatalog && accordion) {
                navigationCatalog.addEventListener(
                    "click",
                    (e) => {
                        e.target.closest("#navigationCatalogTutorial").classList.toggle("_open")
                        accordion.classList.toggle("_close")
                    },
                    {passive: true}
                )

                const items = document.querySelectorAll(".accordion button")

                const closedItems = Array.from(items).filter((item) => item.getAttribute("aria-expanded") === "false")

                if (closedItems.length === 4) {
                    items[0].setAttribute("aria-expanded", "true")
                }

                const toggleAccordion = (event) => {
                    const clickedItem = event.currentTarget
                    const isExpanded = clickedItem.getAttribute("aria-expanded") === "true"

                    items.forEach((item) => item.setAttribute("aria-expanded", "false"))

                    if (!isExpanded) {
                        clickedItem.setAttribute("aria-expanded", "true")
                    }
                }

                if (items.length > 0) {
                    items.forEach((item) => item.addEventListener("click", toggleAccordion))
                }
            }
        },
        {passive: true}
    )
}
